<!--
 * @Author: Gaho
 * @Date: 2024-02-27 10:25:24
 * @LastEditors: Merlin
 * @LastEditTime: 2025-04-22 18:31:52
 * @Description: 全局Loading组件
-->
<template>
    <div v-show="isShowing && 1" :style="{ '--fade-out-time': `${fadeOutTime}ms` }" class="preloader" :class="{
            [keyForControl]: true,
            hiding: fadingOut,
        }">
        <!-- ↓ 在游戏间切换时的 loading 遮罩不显示此进度条，原版如此 -->
        <!-- ↓ 使 is growing -->
        <div class="preloader-progress growing"></div>
        <!-- ↓ 位于中心的 logo 图 -->
        <img class="site-logo" src="@/assets/BetCorgiLogo/Site-logo-411x111-B.webp" />
        <ClientOnly>
            <p v-if="browserInfo" class="text-white absolute bottom-[10px] mx-auto version">
                {{ browserInfo?.name }} v{{ browserInfo?.version }}
            </p>
        </ClientOnly>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useLoadingStore } from '@/stores/loading';

// ↓ 这是 store 中的键名
export type KeyName = '' | 'showLoading' | 'gameLoading';

export default defineComponent({
    name: 'Loading',
    props: {
        keyForControl: {
            type: String as PropType<KeyName>,
            default: 'showLoading',
        },
    },
    data() {
        const loadingStore = useLoadingStore();
        const isShowing = loadingStore[this.keyForControl];
        const browserInfo = getBrowserInfo();
        // console.log(`${this.keyForControl} -- isShowing 👽`, isShowing);
        return {
            loadingStore,
            isShowing, // 默认为 true 在服务端预先准备好遮罩
            fadingOut: false, // 渐隐退场
            fadeOutTime: 500, // 毫秒
            browserInfo,
        };
    },
    computed: {
        isVisible() {
            const bResult = this.loadingStore[this.keyForControl];
            return bResult;
        },
    },
    watch: {
        isVisible(newVal, oldVal) {
            if (newVal) {
                console.log('立即正在打开遮罩 =>', this.keyForControl);
                this.fadingOut = false;
                this.isShowing = true;
                return;
            }
            // ↑ 正在打开遮罩
            // ↓ 正在关闭
            this.fadingOut = this.keyForControl === 'showLoading';
            let iDelay = 0;
            if (this.fadingOut) {
                iDelay = this.fadeOutTime + 100; // 加 100，为了使动画彻底结束之后再隐藏 dom
            }
            console.log(`关闭 Loading 遮罩延时：`, iDelay);
            setTimeout(() => {
                this.isShowing = false;
                // this.$nextTick(()=> this.fadingOut = false);
            }, iDelay);
        },
    },
});
</script>

<style lang="scss" scoped>
.preloader {
    background-color: rgba(0, 0, 0, 1);
    position: fixed;
    z-index: 9999;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    &.gameLoading {
        background-color: #0d131c;
        width: 100%;
        height: 100vh; // 如果这里使用 101vh 将“可能使” 滚动条始终显示，否则滚动条将在显隐之间切换，导致页面抖动
        z-index: 90; // 改小一些，否则会误遮住顶部 header
        .preloader-progress {
            display: none;
        }
    }
    &.hiding {
        pointer-events: none;
        background-color: transparent;
        .site-logo,
        .version {
            display: none !important;
        }
        .preloader-progress {
            // ↓ 值太小将导致无法完全的走到最右侧，目前 110vw 是足够的
            transform: translateX(110vw);
            &:after {
                transform: translateX(50vw);
            }
        }
    }
    .site-logo {
        user-select: none;
        width: 90%; // 改到 90% 防止小屏时过于贴近左右两侧
        max-width: 320px;
        height: auto;
        -webkit-tap-highlight-color: transparent;
        opacity: 1;
        animation: fadein infinite 1.5s ease-in alternate; 
        will-change: opacity; 
    }

    // p {
    //     font-family: system-ui, -apple-system, 'Segoe UI', 'Roboto', 'Ubuntu', 'Cantarell',
    //         'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
    //         'Noto Color Emoji' !important;
    //     color: #ed1d49;
    //     margin: 0.5em 0 0;
    // }

    // ↓ 滚动条
    .preloader-progress {
        width: 5%;
        left: -10px;
        &,
        &:after {
            background-color: #ed1d49;
            position: absolute;
            top: 0;
            height: 8px;
            border-radius: 8px;
            transition-property: all;
            transition-duration: var(--fade-out-time);
            transition-timing-function: linear;
            transform: translateX(0%);
            display: block;
        }
        &:after {
            content: '';
            width: 100%;
            left: 0;
        }
    }
}

.growing {
    animation-name: growing-anim;
    animation-duration: 9s;
    animation-direction: forwards; 
}

@keyframes growing-anim {
    0% {
        width: 5%;
    }
    50% {
        width: 70%;
    }
    100% {
        width: 80%;
    }
}
@keyframes fadein {
    from {
        opacity: 0.3;
    }
    to {
        opacity: 1;
    }
}
</style>
